<template>
  <div>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td class="centro">
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Nombre</th>
          <th scope="col">Perfil</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <!--           <th scope="col">Modulo Administracion</th>
          <th scope="col">Modulo Atencion</th>
          <th scope="col">Modulo Facturacion</th>
          <th scope="col">Modulo Dashboards</th>
          <th scope="col">Menu Parametros</th>
          <th scope="col">Menu Procesos</th>
          <th scope="col">Menu Reportes</th>
          <th scope="col">Menu Ayuda</th>
          <th scope="col">Opcion Consulta</th>
          <th scope="col">Opcion Operaciones</th>
          <th scope="col">Opcion Descarga</th>
          <th scope="col">Opcion Menu</th> -->
          <!-- <th scope="col">SuscripcionFechaReg</th> -->
          <!-- <th scope="col">EmpresaNombre</th> -->
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usuario in datosPaginados" :key="usuario.idUsuario">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(usuario.idUsuario)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(usuario.idUsuario)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ usuario.nombre }}</td>
          <td>{{ usuario.perfilNombre }}</td>
          <td>{{ getFormattedDate(usuario.fechaReg, "DD/MM/YYYY") }}</td>
          <td>{{ getFormattedDate(usuario.fechaAct, "DD/MM/YYYY") }}</td>
          <!--           <td>{{usuario.moduloAdministracion}}</td>
          <td>{{usuario.moduloAtencion}}</td>
          <td>{{usuario.moduloFacturacion}}</td>
          <td>{{usuario.moduloDashboards}}</td>
          <td>{{usuario.menuParametros}}</td>
          <td>{{usuario.menuProcesos}}</td>
          <td>{{usuario.menuReportes}}</td>
          <td>{{usuario.menuAyuda}}</td>
          <td>{{usuario.opcionConsulta}}</td>
          <td>{{usuario.opcionOperaciones}}</td>
          <td>{{usuario.opcionDescarga}}</td>
          <td>{{usuario.opcionMenu}}</td> -->
          <!-- <td>{{getFormattedDate(usuario.suscripcionFechaReg, 'DD/MM/YYYY')}}</td> -->
          <!-- <td>{{usuario.empresaNombre}}</td> -->
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteUsuario(usuario.idUsuario)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuario" class="form-label">IdUsuario</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuario"
                      name="idUsuario"
                      v-model="datoUsuario.idUsuario"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPerfil"
                      name="idPerfil"
                      v-model="datoUsuario.idPerfil"
                    >
                      <option
                        v-for="perfil in perfils"
                        :value="perfil.idPerfil"
                        :key="perfil.idPerfil"
                      >
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label">
                      Suscripcion</label
                    >
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idSuscripcion"
                      name="idSuscripcion"
                      v-model="datoUsuario.idSuscripcion"
                    >
                      <option
                        v-for="suscripcion in suscripcions"
                        :value="suscripcion.idSuscripcion"
                        :key="suscripcion.idSuscripcion"
                      >
                        {{ suscripcion.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Suscripcion -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoUsuario.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="clave" class="form-label">Clave</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="clave"
                      name="clave"
                      v-model="datoUsuario.clave"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label"
                      >IdUsuarioReg</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioReg"
                      name="idUsuarioReg"
                      v-model="datoUsuario.idUsuarioReg"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label"
                      >IdUsuarioAct</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idUsuarioAct"
                      name="idUsuarioAct"
                      v-model="datoUsuario.idUsuarioAct"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label"
                      >Fecha de registro</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="fechaReg"
                      name="fechaReg"
                      v-model="datoUsuario.fechaReg"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="date"
                      class="form-control"
                      id="fechaAct"
                      name="fechaAct"
                      v-model="datoUsuario.fechaAct"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloAdministracion" class="form-label"
                      >ModuloAdministracion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloAdministracion"
                      name="moduloAdministracion"
                      v-model="datoUsuario.moduloAdministracion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloAtencion" class="form-label"
                      >ModuloAtencion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloAtencion"
                      name="moduloAtencion"
                      v-model="datoUsuario.moduloAtencion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloFacturacion" class="form-label"
                      >ModuloFacturacion</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloFacturacion"
                      name="moduloFacturacion"
                      v-model="datoUsuario.moduloFacturacion"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="moduloDashboards" class="form-label"
                      >ModuloDashboards</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="moduloDashboards"
                      name="moduloDashboards"
                      v-model="datoUsuario.moduloDashboards"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuParametros" class="form-label"
                      >MenuParametros</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuParametros"
                      name="menuParametros"
                      v-model="datoUsuario.menuParametros"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuProcesos" class="form-label"
                      >MenuProcesos</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuProcesos"
                      name="menuProcesos"
                      v-model="datoUsuario.menuProcesos"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuReportes" class="form-label"
                      >MenuReportes</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuReportes"
                      name="menuReportes"
                      v-model="datoUsuario.menuReportes"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="menuAyuda" class="form-label">MenuAyuda</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="menuAyuda"
                      name="menuAyuda"
                      v-model="datoUsuario.menuAyuda"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionConsulta" class="form-label"
                      >OpcionConsulta</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionConsulta"
                      name="opcionConsulta"
                      v-model="datoUsuario.opcionConsulta"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionOperaciones" class="form-label"
                      >OpcionOperaciones</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionOperaciones"
                      name="opcionOperaciones"
                      v-model="datoUsuario.opcionOperaciones"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionDescarga" class="form-label"
                      >OpcionDescarga</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionDescarga"
                      name="opcionDescarga"
                      v-model="datoUsuario.opcionDescarga"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="opcionMenu" class="form-label"
                      >OpcionMenu</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="opcionMenu"
                      name="opcionMenu"
                      v-model="datoUsuario.opcionMenu"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarUsuario"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarUsuario"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  props: {
    p_idSuscripcion: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      usuarios: [],
      datoUsuario: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      perfils: [],
      suscripcions: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchPerfils();
    this.fetchSuscripcions();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.usuarios.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwusuarios/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.usuarios = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.usuarios.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwusuarios/idsuscripcion/" +
            this.p_idSuscripcion
        )
        .then((response) => {
          this.usuarios = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.usuarios.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = [
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
        "moduloAdministracion",
        "moduloAtencion",
        "moduloFacturacion",
        "moduloDashboards",
        "menuParametros",
        "menuProcesos",
        "menuReportes",
        "menuAyuda",
        "opcionConsulta",
        "opcionOperaciones",
        "opcionDescarga",
        "opcionMenu",
      ];
      const requiredFieldsText = [
        "idEmpresa",
        "idPerfil",
        "idSuscripcion",
        "nombre",
        "clave",
        "moduloAdministracion",
        "moduloAtencion",
        "moduloFacturacion",
        "moduloDashboards",
        "menuParametros",
        "menuProcesos",
        "menuReportes",
        "menuAyuda",
        "opcionConsulta",
        "opcionOperaciones",
        "opcionDescarga",
        "opcionMenu",
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },
    async guardarUsuario() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuario.idUsuario =
            window.sessionStorage.getItem("idUsuario");
          this.datoUsuario.idEmpresa =
            window.sessionStorage.getItem("idEmpresa");
          this.datoUsuario.idUsuarioReg =
            window.sessionStorage.getItem("idUsuarioReg");
          await api.post("/usuarios",
            this.datoUsuario
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "Usuario creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarUsuario() {
      if (this.validarForm() === 1) {
        try {
          this.datoUsuario.idUsuarioAct =
            window.sessionStorage.getItem("idUsuarioAct");
          await api.post("/usuarios",
            this.datoUsuario
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Usuario creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoUsuario = {};
      this.titulo = "Crear Usuarios";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idUsuario) {
      this.modalWindow = true;
      if (idUsuario != null) {
        api.get("/vwusuarios/" + idUsuario)
          .then((resp) => {
            this.datoUsuario = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar Usuarios";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idUsuario) {
      if (idUsuario != null) {
        this.$router.push("/usuarioform/" + idUsuario);
      }
    },
    async deleteUsuario(idUsuario) {
      try {
        await api.delete("/usuarios/" + idUsuario
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchPerfils() {
      fetch(config.apiBaseUrl + "/perfils")
        .then((response) => response.json())
        .then((data) => {
          this.perfils = data;
        })
        .catch((error) => {
          console.error("Error fetching perfils:", error);
        });
    },
    fetchSuscripcions() {
      fetch(config.apiBaseUrl + "/suscripcions")
        .then((response) => response.json())
        .then((data) => {
          this.suscripcions = data;
        })
        .catch((error) => {
          console.error("Error fetching suscripcions:", error);
        });
    },
  },
};
</script>
